module.exports = __webpack_public_path__ + "static/img/project3.95bde1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project3.png
// module id = 1wZz
// module chunks = 1